import { getAxiosConfigUserToken, openPDFFile } from "app/utils/appHelpers";
import axios from "axios";
import config from "config";


export const getReportListByMeetingIdPDFApi = async (meetingId, type) => {
    const url = `${config.apiUrl}/v1/pdf/reportList/${meetingId}/${type}`;
    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
            return file;
        }).then(file => openPDFFile(file))
}


export const getOneRecordByIdPDFApi = async (meetingId, decisionId, type) => {

    const url = `${config.apiUrl}/v1/pdf/oneRecord/${meetingId}/${decisionId}/${type}`;
    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
            return file;
        }).then(file => openPDFFile(file))
}

export const getUsersByMeetingIdPDFApi = async (meetingId, type) => {

    const url = `${config.apiUrl}/v1/pdf/meetingUsers/${meetingId}/${type}`;
    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
            return file;
        }).then(file => openPDFFile(file))
}


export const getPDFForEachDecisionByMeetingIdPDFApi = async (meetingId) => {

    const url = `${config.apiUrl}/v1/pdf/eachDecision/${meetingId}`;
    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
            return file;
        }).then(file => openPDFFile(file))
}


export const getUnclearSignaturePDFApi = async (meetingId, fullName, position) => {
    const url = `${config.apiUrl}/v1/pdf/unclearSignature/${meetingId}`;

    return axios
        .get(url, {
            method: 'GET',
            responseType: 'blob',
            params: { fullName, position }, // API'ye gönderilen parametreler
            ...getAxiosConfigUserToken(),
        })
        .then((response) => {
            const file = new Blob([response.data], { type: 'application/pdf' });
            return file;
        })
        .then((file) => openPDFFile(file));
};


// export const getDstatusSearchListByMeetingIdPDFApi = async (payload) => {
//     const url = `${config.apiUrl}/v1/pdf/dstatusSearchList/`;
//     return axios.post(url, payload, {
//         responseType: 'blob',
//         ...getAxiosConfigUserToken()
//     })
//         .then(response => {
//             const file = new Blob([response.data], { type: 'application/pdf' });
//             return file;
//         })
//         .then(file => openPDFFile(file));
// };

export const getDstatusSearchListByMeetingIdPDFApi = async (payload) => {
    const url = `${config.apiUrl}/v1/pdf/dstatusSearchList/`;

    return axios.post(url, payload, {
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob([response.data], { type: 'application/pdf' });
            return file;
        })
        .then(file => openPDFFile(file));
};

export const getDetailSearchByMeetingIdPDFApi = async (payload) => {
    const url = `${config.apiUrl}/v1/pdf/detailSearchList/`;

    return axios.post(url, payload, {
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob([response.data], { type: 'application/pdf' });
            return file;
        })
        .then(file => openPDFFile(file));
};

export const getMergedReportPDFApi = async (meetingId) => {
    const url = `${config.apiUrl}/v1/pdf/mergedReport/${meetingId}`;
    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
            return file;
        }).then(file => openPDFFile(file))
}




